export const SPORTS_OVERLAYS_ID = 'sports-overlays';
